const TABLE_OFFSET_DEFAULT = 155;
const TABLE_OFFSET_VIEW_MODE = 305;

export { TABLE_OFFSET_DEFAULT, TABLE_OFFSET_VIEW_MODE };
